import React, {
  useState, useEffect, cloneElement, Children,
} from 'react';
import ReactDOM from 'react-dom';
import ComponentErrorBoundary from 'core/modules/ErrorBoundaries/ComponentErrorBoundary';

import './SlideMenu.scss';

function SlideMenu({ customButtonClassName, buttonText = 'Filter', children }) {
  const [shouldShowOverlay, setShouldShowOverlay] = useState(false);

  const showOverlay = () => setShouldShowOverlay(true);
  const hideOverlay = () => setShouldShowOverlay(false);

  useEffect(() => {
    setTimeout(() => {
      // Added timeout to make sure the animation is applied AFTER element is added to the DOM
      document.documentElement.classList.toggle('mn_openFiltersMenu', shouldShowOverlay);
    }, 50);
  }, [shouldShowOverlay]);

  return (
    <>
      <button
        onClick={showOverlay}
        className={`mn_slideMenuTrigger ${customButtonClassName}`}
      >
        <i className="mn_slideMenuIcon" aria-hidden="true" />
        <span>{buttonText}</span>
      </button>
      {shouldShowOverlay && ReactDOM.createPortal(
        <div className="mn_slideMenuContent">
          <button className="mn_closeButton" onClick={hideOverlay}>&#x2715;</button>
          {Children.map(children, (child) => (cloneElement(child, { hideOverlay })))}
        </div>,
        document.getElementById('app'),
      )}
    </>
  );
}

export default (props) => <ComponentErrorBoundary><SlideMenu {...props} /></ComponentErrorBoundary>;
